import { DependencyContext } from "@revideo/core";

/**
 * An image the scene needs in hand before it draws (a pattern tile, a picture whose size decides its cover-fit): decoded
 * ahead of the first frame, with the frame held until it is.
 */
export function loadImage(src: string): HTMLImageElement {
  const img = new Image();
  img.crossOrigin = "anonymous";
  img.src = src;
  if (typeof img.decode === "function") DependencyContext.collectPromise(img.decode().then(() => true, () => false), false);
  return img;
}

/** Cover-fit: the size a `nw`×`nh` picture takes to fill a `w`×`h` box without letterboxing. */
export function coverSize(nw: number, nh: number, w: number, h: number): [number, number] {
  if (!nw || !nh) return [w, h];
  const s = Math.max(w / nw, h / nh);
  return [nw * s, nh * s];
}
